
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { DataService } from '@/service/DataService';
import StatusIcon from '@/components/room/users/StatusIcon.vue';

import { UserRoomStateData, StatusItem, VolumeModes, Room, User } from '@/utils/models';
import { NO_SOUND_THRESHOLD_DISTANCE } from '@/utils/constants';

@Component({
  components: {
    StatusIcon,
  },
})
export default class ToolsPanel extends Vue {
  @Prop() private dataServiceRef!: DataService;
  @Prop() private room!: Room;
  @Prop() private user!: UserRoomStateData;
  @Prop() isLocalVideoDisabled!: boolean;
  @Prop() isLocalAudioDisabled!: boolean;
  @Prop() volumeMode!: VolumeModes;
  @Prop() currentSubRoomId!: string;
  @Prop() sharedCount!: number;

  @Prop() toggleLocalVideo!: () => void;
  @Prop() toggleLocalAudio!: () => void;
  @Prop() leaveRoom!: () => void;

  @Emit()
  openBoardSetting(): void {}
  @Emit()
  toggleShareScreen(): void {}
  @Emit()
  openGlobalSetting() {}
  @Emit()
  switchToMode(): VolumeModes {
    return this.volumeMode == 'DistanceSensitive' ? 'Muted' : 'DistanceSensitive';
  }
  @Emit()
  openTeamsAndNotifyOpen() {}
  @Emit()
  changeCollapsed(collapsed: boolean) {}
  @Emit()
  toggleShowStatusSelector(e: Event) {}
  @Emit()
  minimapClick() {}

  userMessage = '';

  get isDebugMode(): boolean {
    return this.$store.state.isDebugMode;
  }
  get isAdmin(): boolean {
    return !!(this.$store.state.user as User)?.roles?.find((r) => r.id === 'Admin');
  }

  get avatarBase64(): string {
    return this.user?.userState.user.avatarBase64 ?? '';
  }
  get avatarShape(): 'circle' | 'rectangle' {
    return this.user?.userState.user.avatarShape ?? 'circle';
  }
  get name(): string {
    return this.user?.userState.user.name ?? '';
  }
  get status(): string {
    return this.user?.userState.status ?? '';
  }
  get isVideoAvailable(): boolean {
    return this.$store.state.isVideoAvailable;
  }
  get isAudioAvailable(): boolean {
    return this.$store.state.isAudioAvailable;
  }
  get isInSubRoom(): boolean {
    return this.currentSubRoomId !== this.room.id;
  }
  get countMembers(): number {
    const mem = this.room.subRooms
      .find((s) => s.subid === this.currentSubRoomId)
      ?.userStates.filter((u) => u.userState.user.email);
    return mem?.length ?? -1;
  }
  get canOpenTeams(): boolean {
    if (!this.isInSubRoom) {
      return false;
    }
    return this.countMembers > 1;
  }

  get isScreenSharing(): boolean {
    return this.$store.state.isScreenSharing;
  }
  get isShowEditor(): boolean {
    return this.$store.state.isShowEditor ?? false;
  }
  get isCapturePictureInPicture() {
    return this.$store.state.isCapturePictureInPicture;
  }
  get pipMode() {
    return this.$store.state.pipMode;
  }
  private mounted(): void {
    if (this.$refs.toolsPanelRef && this.$store.state.isIPad) {
      const toolsPanel: HTMLDivElement = this.$refs.toolsPanelRef as HTMLDivElement;
      toolsPanel.style.bottom = '40px';
    }
  }
  toggleVoideArea() {
    const voiceArea = this.user.userState.voiceArea ?? 150;
    let next = voiceArea > 150 ? voiceArea - 150 : NO_SOUND_THRESHOLD_DISTANCE;
    this.dataServiceRef.emitVoiceArea(next);
    this.$store.commit('SetIsMoving', true);
  }
  setMoving(isMove: boolean) {
    this.$store.commit('SetIsMoving', isMove);
  }
  beforeDestroy() {}
  copyUrlLink(): void {
    const url: string = window.location.href;
    const urlNoParams = url.split('?')[0];
    navigator.clipboard.writeText(urlNoParams).then(
      () => {
        this.$toast.info('このルームへのリンクがクリップボードへコピーされました');
      },
      () => {
        this.$toast.error('リンクがコピーできませんでした');
      },
    );
  }
  switchMessageEditorVisibility() {
    this.$store.commit('SetIsShowEditor', !this.isShowEditor);
    this.$store.commit('SetDefaultEditingMessage', '');
  }
}
